import { createContext, useCallback, useContext, useMemo, useState } from "react";

const AuthGateContext = createContext(null);

export const AuthGateProvider = ({ children }) => {
  const [authGate, setAuthGate] = useState({
    isOpen: false,
    reason: null,
    redirectTo: null,
  });

  const openAuthGate = useCallback(({ reason = "auth_required", redirectTo = null } = {}) => {
    setAuthGate({ isOpen: true, reason, redirectTo });
  }, []);

  const closeAuthGate = useCallback(() => {
    setAuthGate((prev) => ({ ...prev, isOpen: false }));
  }, []);

  const value = useMemo(
    () => ({ authGate, openAuthGate, closeAuthGate }),
    [authGate, openAuthGate, closeAuthGate]
  );

  return <AuthGateContext.Provider value={value}>{children}</AuthGateContext.Provider>;
};

export const useAuthGate = () => {
  const ctx = useContext(AuthGateContext);
  if (!ctx) throw new Error("useAuthGate must be used within AuthGateProvider");
  return ctx;
};

